module.exports = __webpack_public_path__ + "img/3修改晶格20220420_101120.320486f3.gif";